export const logisticsTeam = [
  ["11256", "Rory Goode"],
  ["15067", "Alexis Sanchez"],
  ["15600", "Aaron Hampton"],
  ["17290", "Ross Sylvester"],
];
